var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
export const CardHelp = ({ children }) => (_jsx("div", { className: "text-secondary font-italic pt-3 px-4", children: children }));
// eslint-disable-next-line react/display-name
const CustomCard = React.forwardRef((_a, ref) => {
    var { title, children, className, subTitle, headerRightContent, noShadow, customHeader, hideTitleOnXl, alignHeaderTop, selected, headerClass } = _a, otherProps = __rest(_a, ["title", "children", "className", "subTitle", "headerRightContent", "noShadow", "customHeader", "hideTitleOnXl", "alignHeaderTop", "selected", "headerClass"]);
    return (_jsxs("div", Object.assign({}, otherProps, { ref: ref, className: classNames("card " + (className || ""), {
            shadow: !noShadow,
            "border-primary": selected,
        }), children: [customHeader ||
                // Otherwise show the standard components
                ((title || headerRightContent) && (_jsxs("div", { className: classNames("card-header bg-white d-flex justify-content-between ", {
                        "align-items-center": !alignHeaderTop,
                    }, headerClass), children: [_jsxs("div", { children: [_jsx("h2", { className: classNames("mb-0 card-title h5", {
                                        "d-none d-xl-block": hideTitleOnXl,
                                    }), children: title }), subTitle] }), headerRightContent && (_jsx("div", { className: "flex-grow-1 text-right", children: headerRightContent }))] }))), children] })));
});
export default CustomCard;
